/**
 * The purpose of this pipe is to extract the record ids from a list of records based on the entity type.
 */
import { Pipe, PipeTransform } from '@angular/core';
import { digger } from '@cbre/digger';
import { EntityType } from '@miq/domain';

@Pipe({
  name: 'getRecordIds',
  standalone: true,
})
export class GetRecordIdsPipe implements PipeTransform {
  #getEntityId = record => digger(record, 'entity.id');
  #getUsageId = (property: Record<string, any>) => property?.usages?.map(u => u.id);

  #idsPath = { [EntityType.Property]: this.#getUsageId };

  transform(records: Record<string, any> = [], entity: EntityType): number[] {
    const idGetter = this.#idsPath[entity] ?? this.#getEntityId;
    return (records ?? []).flatMap(idGetter);
  }
}
